import { FilterOption, RawOption } from './types';

export const loadFilterOptions = (options: RawOption[]): FilterOption[] => {
  return options.map(({ id, name }) => ({ value: id, label: name }));
};
